import React, { useMemo } from "react";
import styles from "./Reporting.module.scss";
import Grid from "@mui/material/Grid";
import { withTranslation } from "react-i18next";
import SubNav from "../../shared/subnav/SubNav";
import { base64FileDownload, fileDownload } from "../../utils/FileDownloadUtil";
import { logMsg } from "../../common/Logger";
import DownloadButton from "../../shared/buttons/DownloadButton";
import { InfoIconWithMessage } from "../../shared/infoIcon/InfoIcon";
import NscReportingClient from "../../shared/clients/NscReportingClient";

const Reporting = (props) => {
  const downloadDealerActivationReport = (report) => {
    props.hideOrShow(true);
    NscReportingClient.downloadDealerActivationReportInCsv(props.user)
      .then((res) => {
        const filename = props.t(report.name) + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const downloadInventoryPricingReport = () => {
    props.hideOrShow(true);

    const nscColumnHeaders = props.t(
      "Reporting.nscInventoryPricingReportHeaders"
    );

    const data = {
      columnHeaders: nscColumnHeaders,
    };

    NscReportingClient.downloadInventoryPricingReport(props.user, data)
      .then((res) => {
        const filename =
          props.t("Reporting.nscInvPricingReportTitle") +
          " - " +
          getTodayDateDDMMYYYY() +
          ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const downloadInventoryPricingHistoryReport = () => {
    props.hideOrShow(true);
    const nscColumnHeaders = props.t(
      "Reporting.nscInventoryPricingReportHeaders"
    );

    const data = {
      columnHeaders: nscColumnHeaders,
    };

    NscReportingClient.downloadInventoryPricingHistoryReport(props.user, data)
      .then((res) => {
        const filename =
          props.t("Reporting.nscInventoryHistoryReportTitle") +
          " - " +
          getTodayDateDDMMYYYY() +
          ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const getTodayDateDDMMYYYY = () => {
    const today = new Date();
    return `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
  };

  const reports = useMemo(() => {
    const commonReport = [
      {
        name: "Reporting.report1Title",
        key: "report1",
        downloadLink: downloadDealerActivationReport,
      },
    ];

    return [
      ...commonReport,
      {
        name: "Reporting.nscInvPricingReportTitle",
        downLoadName: "Reporting.nscInvPricingReportTitle",
        key: "report8",
        downloadLink: downloadInventoryPricingReport,
      },
      {
        name: "dealerReporting.report6Name",
        downLoadName: "dealerReporting.report6Name",
        key: "report6",
        downloadLink: downloadInventoryPricingHistoryReport,
      },
    ];
  }, []);

  return (
    <div id="reporting">
      <section className="pageWrapper">
        <div id="reportingHeader">
          <SubNav
            dashboard={false}
            title={props.t("Reporting.subnav1")}
            {...props}
          />
        </div>
        <div className="pagePaddingLeft pagePaddingTop">
          <InfoIconWithMessage message={props.t("Reporting.bodyCopy")} />
        </div>
        <div>
          <Grid container className={styles.dataContainer}>
            <Grid
              item
              className={`${styles.headerContainer} ${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
            >
              <div>{props.t("Reporting.columnTitle1")}</div>
            </Grid>
            {reports.map((report) => (
              <React.Fragment key={report.key}>
                <Grid
                  container
                  className={`${styles.rowDiv} pagePaddingLeft pagePaddingRight`}
                >
                  <Grid item md={10}>
                    <div className={styles.colValues}>
                      {props.t(report.name)}
                    </div>
                  </Grid>
                  <Grid item md={2} className={`${styles.end}`}>
                    <DownloadButton
                      download={() => report.downloadLink(report)}
                      text={props.t("Reporting.download")}
                    />
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </div>
      </section>
    </div>
  );
};

export default withTranslation("emp")(Reporting);
